<div class="widget form-group" [class.has-error]="control.invalid">
  <label>
    {{ schema.title }}
    <sp-widget-tooltip [widget]="this"></sp-widget-tooltip>
  </label>
  <div *ngFor="let option of options" class="radio">
    <label class="horizontal control-label">
      <input [formControl]="control" [attr.name]="name" value="{{ option.value }}" type="radio" [attr.disabled]="schema.readOnly" />
      {{ option.label }}
    </label>
  </div>
  <input *ngIf="schema.readOnly" [attr.name]="name" type="hidden" [formControl]="control" />
  <span *ngIf="schema.description" class="help-block">{{ schema.description }}</span>
  <sp-widget-error [widget]="this" [errors]="control.errors"></sp-widget-error>
</div>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/radio.widget.html